import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import Land from "./landing-page/LandingPage.tsx";
import { IntlProviderWrapper } from "./landing-page/components/IntlProviderWrapper.tsx";
import { initSecureCookieInterceptor } from "./utils/secureCookieInterceptor";

// セキュアなcookieインターセプターを初期化
initSecureCookieInterceptor();
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(  
<React.StrictMode>
<IntlProviderWrapper>
{/* <IntlProvider locale={navigator.language} messages={selectMessages()}> */}
  <Land /> 
  {/* </IntlProvider> */}
 </IntlProviderWrapper> 
</React.StrictMode>,);